'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StylishButton_1 = require("../StylishButton");
var Styles = require("../../styles");
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function () {
        return (React.createElement("div", { id: 'menu', style: Styles.menu },
            React.createElement(StylishButton_1.StylishButton, { id: 'new-game-btn', styles: Styles.newGameButton, text: 'New Game', events: { onClick: this.props.onNewGame } }),
            React.createElement(StylishButton_1.StylishButton, { id: 'reset-game-btn', styles: Styles.resetGameButton, text: 'Reset Game', events: { onClick: this.props.onResetGame } }),
            React.createElement("a", { href: 'https://github.com/PedroHenriques/Minesweeper', target: '_blank', style: Styles.githubLink }, "Source Code")));
    };
    return Menu;
}(React.Component));
exports.Menu = Menu;
//# sourceMappingURL=Menu.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/App/Menu.js
// module id = 27
// module chunks = 0